export var keyCode;

(function (keyCode) {
  keyCode["Down"] = "ArrowDown";
  keyCode["Up"] = "ArrowUp";
  keyCode["Left"] = "ArrowLeft";
  keyCode["Right"] = "ArrowRight";
  keyCode["Enter"] = "Enter";
  keyCode["Esc"] = "Escape";
  keyCode["Space"] = "Space";
  keyCode["Backspace"] = "Backspace";
})(keyCode || (keyCode = {}));